import React, { ReactElement } from 'react';
import { Row, Col, Button, Grid } from 'antd';
import HeroImage from '../../assets/hero.svg';
import './Welcome.styles.css';
const defaultProps = {};
type WelcomeProps = {} & typeof defaultProps;
const { useBreakpoint } = Grid;
export const Welcome = ({}: WelcomeProps): ReactElement => {
	const { lg } = useBreakpoint();
	return (
		<div className='container hero'>
			<Row>
				<Col
					xl={12}
					xs={24}
					md={12}
					className='hero-details'
					style={{ order: lg ? 1 : 2 }}>
					<Row
						//@ts-ignore
						justify={`${lg ? 'start' : 'center'}`}>
						<h1
							className='hero-title'
							style={{ textAlign: lg ? 'start' : 'center' }}>
							PDF from Images
						</h1>
					</Row>
					<Row>
						<h2 style={{ textAlign: lg ? 'start' : 'center' }}>
							This web site is under development
							{/* 100% free tool to genarate pdf files using camera
							captured images. Once loaded,tool will work without
							an internet connection */}
						</h2>
					</Row>

					<Row //@ts-ignore
						justify={`${lg ? 'start' : 'center'}`}>
						<button className='hero-button'>Use the tool</button>
						<button className='hero-button-future'>
							Future updates
						</button>
					</Row>
				</Col>
				<Col
					xl={12}
					xs={24}
					md={12}
					className='hero-image-div'
					style={{ order: lg ? 2 : 1 }}>
					<img
						src={HeroImage}
						alt='hero image'
						className='hero-image'
						width={'80%'}
					/>
				</Col>
			</Row>
		</div>
	);
};
Welcome.defaultProps = defaultProps;
